var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"toolkit-item",attrs:{"title":"Hợp đồng thuê xe mẫu","aria-label":"Contract template","href":"https://sorentohybrid.kiavietnam.com.vn/storage/e-brochure-sorento-hev-phev-v1201222-s.pdf","target":"_blank"}},[_c('div',{staticClass:"wrap-button"},[_c('p',[_vm._v("Hợp đồng mẫu")])])])
}]

export { render, staticRenderFns }